import axios from "axios"
import {
     CONST_API_DASHBOARD_GET_ALERTES_STAFF_AVEC_DOCS_EMBAUCHE_NON_ENVOYES_ENDPOINT,
     CONST_API_DASHBOARD_STAFF_DOCS_EMBAUCHE_PREVIEW_ENDPOINT,
     CONST_API_DASHBOARD_STAFF_DOCS_EMBAUCHE_ENVOYER_ENDPOINT,
} from "../../../../endpoints"
import { IPersonnelDEDocumentsEmbauchePreviewModel } from "../../../personnel/core/_requests"

export interface IStaffDocsEmbaucheNonEnvoyesItem {
     demandeId: number
     personnelId: number | null
     collaborateur: string
     entite: string | null
     statut: string | null
     etat: string | null
     etatLabel: string | null
     dateDemande: string | null
     createur: string | null
     mailPersonnel: string | null
}

export function getAlertesStaffAvecDocsEmbaucheNonEnvoyesRequest() {
     return axios.get<{ data: IStaffDocsEmbaucheNonEnvoyesItem[] }>(CONST_API_DASHBOARD_GET_ALERTES_STAFF_AVEC_DOCS_EMBAUCHE_NON_ENVOYES_ENDPOINT)
}

// Aperçu de l'envoi des documents d'embauche depuis l'alerte (documents de l'entité + contrat + taille).
export function staffDocsEmbauchePreviewRequest(demandeId: number) {
     return axios.get<IPersonnelDEDocumentsEmbauchePreviewModel>(CONST_API_DASHBOARD_STAFF_DOCS_EMBAUCHE_PREVIEW_ENDPOINT(demandeId))
}

// Envoie les documents d'embauche (contrat inclus par défaut) à l'email personnel du collaborateur.
export function staffDocsEmbaucheEnvoyerRequest(demandeId: number, contratInclus: boolean) {
     return axios.post(CONST_API_DASHBOARD_STAFF_DOCS_EMBAUCHE_ENVOYER_ENDPOINT(demandeId), { contratInclus })
}
